import info from './info/en';

// English — the reference locale. ru.js and it.js must have exactly the same keys
// (checked by scripts/check-locales.mjs).
const en = {
  meta: {
    homeTitle: 'Blissful Play — The Bears Collection | Intimate Gummies for Couples',
    homeDescription: 'Meet the Bears — premium intimate gummies, chocolate and honey for couples. Discreet packaging, fast EU delivery. 18+ only.',
    shopTitle: 'Shop all — Blissful Play',
    categoryTitle: '{{name}} — Blissful Play',
    categoryDescription: 'Shop {{name}} at Blissful Play: premium intimate products for couples, discreet packaging, fast EU delivery. 18+ only.',
    productTitle: '{{name}} — Blissful Play',
    infoTitle: '{{name}} — Blissful Play',
  },
  lang: {
    label: 'Language',
    short: { en: 'EN', ru: 'RU', it: 'IT' },
    name: { en: 'English', ru: 'Русский', it: 'Italiano' },
  },
  nav: {
    strip: 'Free discreet packaging on every order · Fast EU delivery · 18+ only',
    bears: 'Bears ✦ Best sellers',
    shopAll: 'Shop all',
    how: 'How it works',
    faq: 'FAQ',
    cart: 'Cart',
    categories: 'Categories',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  age: {
    badgeAdults: '18+ only',
    badgeDiscreet: 'Discreet',
    title: 'Are you 18 or older?',
    text: 'You must be of legal age to enter this site.',
    enter: 'Yes, enter',
    leave: 'No, leave',
  },
  hero: {
    badgeLimited: 'Limited batch',
    badgeVegan: 'Vegan gummies',
    badgeCouples: 'Made for couples',
    titleStart: 'Make your nights',
    titleAccent: 'sweeter',
  },
  bears: {
    title: 'The Bears Collection',
    perkShipping: 'Express shipping',
    perkPackaging: 'Neutral packaging',
    perkIngredients: 'Premium ingredients',
    prev: 'Previous products',
    next: 'Next products',
  },
  showcase: {
    title: 'Why couples choose the Bears',
    subtitle: 'Natural extracts, a sweet format and complete discretion.',
    open: 'Open full size',
    alt: {
      couple: 'Boner Bears male and Bliss Bears female enhancement gummies next to a smiling couple — Boost your confidence, unleash your inner power',
      ingredients: 'Confidence in every bite: pomegranate extract, cat\'s claw extract, ashwagandha and tongkat ali extract, horny goat weed extract, L-arginine',
      chocolateHoney: 'Boner Bears chocolate and wildflower honey single-dose sachets — easy, convenient and discreet',
      benefits: 'Key benefits: enhanced pleasure, fast-acting formula, safe ingredients, convenient and discreet',
      confidence: 'A couple with Boner Bears and Bliss Bears gummy packs — feel confident, energized and ready',
    },
  },
  categories: {
    title: 'Shop the collection',
    subtitle: 'Curated selections for every kind of pleasure.',
    count_one: '{{count}} product',
    count_other: '{{count}} products',
  },
  categoryNames: {
    vibrators: 'Vibrators',
    'cock-rings': 'Cock Rings',
    'enhancement-gummies': 'Enhancement Gummies',
    'honey-chocolate': 'Honey & Chocolate',
    'adult-toys': 'Adult Toys',
  },
  how: {
    title: 'Simple. Discreet. Effective.',
    steps: [
      { title: 'Choose your pack', description: 'Browse our curated collection of premium intimate products.' },
      { title: 'Enjoy the moment', description: 'Share the experience with your partner.' },
      { title: 'Feel the spark', description: 'Let the magic unfold naturally.' },
    ],
  },
  reviews: {
    title: 'Couples love the Bears',
    stars: '5 out of 5 stars',
    items: [
      { name: 'Sarah M.', text: 'These are incredible! My partner and I had the most amazing evening. The quality is outstanding and the effects are exactly as described. Highly recommend!' },
      { name: 'James R.', text: 'Discreet packaging was perfect. The product itself exceeded our expectations. Will definitely be ordering again!' },
      { name: 'Emily K.', text: 'A game-changer for us. The taste is great and the experience was unforgettable. Five stars all the way!' },
    ],
  },
  privacy: {
    title: 'Your privacy, our priority',
    text: 'Plain, unmarked boxes with no indication of contents. A discreet company name on your statement. We never share your information.',
    packaging: 'Neutral packaging',
    billing: 'Private billing',
  },
  faq: {
    title: 'Questions?',
    items: [
      { question: 'Is this product 18+ only?', answer: 'Yes, absolutely. Blissful Play products are exclusively for adults aged 18 and over. We verify age at entry to our website.' },
      { question: 'Is shipping really discreet?', answer: 'Yes! All orders ship in plain, unmarked packaging with no indication of contents. Your billing statement will show a discreet company name.' },
      { question: 'How long does delivery take?', answer: 'We offer express shipping on all orders. Most deliveries arrive within 3-5 business days. Rush shipping is available at checkout.' },
      { question: 'Are these products safe?', answer: 'Absolutely. All Blissful Play products are made with premium, carefully selected ingredients. Each batch is tested for quality and safety.' },
      { question: 'What if I have more questions?', answer: 'Feel free to reach out to our customer support team. We are here to help with any questions or concerns you may have.' },
    ],
  },
  shop: {
    title: 'Shop all products',
    subtitle: 'Explore our premium collection',
    all: 'All',
    productsCount_one: '{{count}} product',
    productsCount_other: '{{count}} products',
    empty: 'No products in this category yet.',
    viewAll: 'View all products',
    loading: 'Loading products…',
    loadFailed: 'Failed to load products',
  },
  product: {
    addToCart: 'Add to cart',
    added: 'Added',
    addedLive: '{{name}} added to cart',
    soldOut: 'Sold out',
    limited: 'Limited',
  },
  pdp: {
    back: 'Back to shop',
    loading: 'Loading product…',
    notFound: 'Product not found',
    loadFailed: 'Failed to load product',
    view: 'view {{n}}',
    fastDelivery: 'Fast delivery',
    fastDeliveryNote: 'EU 5–12 days',
    discreet: 'Discreet',
    plainPackaging: 'Plain packaging',
    size: 'Option',
    variantSoldOut: '{{size}} is sold out. Pick another option or check back soon.',
    variantLowStock: 'Only {{count}} left of {{size}} — order soon',
    variantSoldOutToast: 'Sorry, this variant is sold out',
    details: 'Product details',
    category: 'Category',
    stock: 'Stock',
    inStock: 'In stock',
    onlyLeft: 'Only {{count}} left',
    delivery: 'Delivery',
    adultsOnly: 'Adults only',
    adultsOnlyText: 'Intended for adults 18 years and older. Keep out of reach of children.',
    addToCartPrice: 'Add to cart — {{price}}',
    secureCheckout: 'Secure checkout',
    privateShipping: 'Private shipping',
  },
  cart: {
    title: 'Your cart',
    empty: 'Your cart is empty',
    total: 'Total',
    checkout: 'Checkout',
    continue: 'Continue shopping',
    close: 'Close cart',
    size: 'Option',
    increase: 'Increase quantity',
    decrease: 'Decrease quantity',
    remove: 'Remove',
    removed: 'Removed from cart',
  },
  checkout: {
    stepShipping: 'Shipping',
    stepPayment: 'Payment',
    shippingTitle: 'Shipping details',
    shippingSubtitle: 'Enter your shipping information',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone number',
    street: 'Street address',
    apartment: 'Apartment / unit',
    optional: '(optional)',
    city: 'City',
    postalCode: 'Postal code',
    country: 'Country',
    required: '{{field}} is required',
    emailInvalid: 'Email is invalid',
    fillRequired: 'Please fill in all required fields',
    discreetTitle: 'Discreet shipping. No branding on packaging.',
    discreetText: 'Your package will arrive in plain, unmarked packaging with no indication of contents.',
    continueToPayment: 'Continue to payment',
    reviewTitle: 'Review & payment',
    reviewSubtitle: 'Confirm your order details',
    shippingAddress: 'Shipping address',
    edit: 'Edit',
    paymentMethod: 'Payment method',
    stripeRedirect: "You will be redirected to Stripe's secure payment page to complete your purchase.",
    securedByStripe: 'Secure checkout powered by Stripe',
    processing: 'Processing…',
    pay: 'Pay {{price}}',
    sessionFailed: 'Failed to create checkout session',
    cartEmpty: 'Your cart is empty',
    continueShopping: 'Continue shopping',
    orderSummary: 'Order summary',
    qty: 'Qty: {{count}}',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    free: 'FREE',
    total: 'Total',
  },
  success: {
    confirming: 'Confirming your payment…',
    title: 'Order confirmed!',
    text: 'Thank you for your purchase. Your order has been received and will be shipped discreetly.',
    orderNumber: 'Order number:',
    emailTitle: 'Confirmation email sent',
    emailText: "We've sent a confirmation email to <1>{{email}}</1> with your order details and tracking information.",
    shippingAddress: 'Shipping address',
    estimatedDelivery: 'Estimated delivery',
    deliveryText: 'Your order will be shipped within 24 hours and typically arrives in 3–5 business days.',
    discreetTitle: 'Discreet shipping. No branding on packaging.',
    discreetText: 'Your package will arrive in plain, unmarked packaging with no indication of contents. Your billing statement will show a discreet company name. Your privacy is our priority.',
    orderSummary: 'Order summary',
    totalPaid: 'Total paid',
    continueShopping: 'Continue shopping',
    backHome: 'Back to home',
    help: 'Need help? Contact us at',
    statusTitle: 'Payment status',
    statusError: 'Error checking payment status',
    statusTimeout: 'Payment verification timed out',
    backToShop: 'Back to shop',
  },
  cancel: {
    title: 'Payment cancelled',
    text: 'Your payment was cancelled. No charges were made to your account.',
    retry: 'Try again',
    continueShopping: 'Continue shopping',
  },
  popup: {
    badge: 'Members only',
    titleStart: 'Get',
    titleAccent: '10%',
    titleEnd: 'off',
    text: 'Join our exclusive list for special offers.',
    emailLabel: 'Email',
    placeholder: 'Enter your email',
    subscribe: 'Subscribe',
    subscribing: 'Subscribing…',
    legal: 'By subscribing, you agree to receive marketing emails. You can unsubscribe anytime.',
    close: 'Close',
    noThanks: 'No, thanks',
    success: 'Successfully subscribed!',
    error: 'Failed to subscribe. Please try again.',
  },
  footer: {
    tagline: 'Premium intimate products designed for couples. Discreetly delivered. Beautifully crafted.',
    shop: 'Shop',
    allProducts: 'All products',
    bundles: 'Bundles',
    information: 'Information',
    adults: 'For adults 18+ only.',
    cookies: 'Cookie settings',
  },
  cookies: {
    title: 'Cookies, discreetly',
    text: 'We only use what the shop needs to work (cart, age check, language). With your OK we also use analytics and marketing cookies to improve the site.',
    onlyNecessary: 'Only necessary',
    acceptAll: 'Accept all',
    customize: 'Customize',
    save: 'Save choices',
    necessary: 'Strictly necessary',
    necessaryDesc: 'Cart, age confirmation and language. Always on.',
    analytics: 'Analytics',
    analyticsDesc: 'Anonymous usage stats that help us improve the shop.',
    marketing: 'Marketing',
    marketingDesc: 'Measure ads and show relevant offers.',
  },
  info,
};

export default en;
